// Modules
import React, { useEffect, useState, useContext } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import ModalResume from "./ModalResume";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
import Pills from "../utils/Pills";
import Table from "../utils/Table";
import Divider from "../utils/Divider";

// Assets
import "./resume.scss";
import "./modal-resume.scss";
import Strategy1 from "../../assets/img/svg/strategy_1_investment";
import Strategy2 from "../../assets/img/svg/strategy_2_balanced";
import Strategy3 from "../../assets/img/svg/strategy_3_development";
import HomeIcon from '@material-ui/icons/Home';
import RoomIcon from '@material-ui/icons/Room';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import EuroIcon from '@material-ui/icons/Euro';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';

const createData = (name, value, key) => {
  return {
    name,
    value,
    key,
  };
};

const DetailsOfRent = (props) => {
  // Props
  const { data, loader } = props;
  const {
    achat_fai,
    loyer_cc,
    rendement_brut,
    descriptif_bien_2,
    resume,
    quartier,
    adresse_bien,
    ville,
    m2_carrez,
    details_loyer,
    statut_locatif,
    strategie,
    photo_charge_projet,
    nom_prenom_cdp,
  } = data;
  const { isMobile, isTablet } = useContext(ApiContext);


  // Parsed data
  const prix_fai = achat_fai
    ? {
      label: "Prix FAI",
      value: new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
      }).format(achat_fai),
    }
    : { label: null, value: null };
  const loyer_annuel = loyer_cc
    ? {
      label: "Loyer annuel",
      value: new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
      }).format(loyer_cc * 12),
    }
    : { label: null, value: null };
  const rdmt_brut = rendement_brut
    ? {
      label: "Rendement brut",
      value: `${rendement_brut} %`,
    } : { label: null, value: null };

  /* Former table with aspect="table" */
  // const rows = [
  //   createData("Type de bien", descriptif_bien_2),
  //   createData("Adresse", adresse_bien && ville ? `${adresse_bien}, ${ville}` : null),
  //   createData("Quartier", quartier),
  //   createData("Surface", m2_carrez ? `${m2_carrez}m² loi Carrez` : null),
  //   createData("Détails du loyer", details_loyer),
  //   createData("Statut locatif", statut_locatif),
  // ];

  const rows = details_loyer
    ? [
      createData(<HomeIcon />, descriptif_bien_2, 0),
      createData(<RoomIcon />, adresse_bien && ville ? `${adresse_bien}, ${ville}` : null, 1),
      createData(<LocationCityIcon />, quartier, 2),
      createData(<AspectRatioIcon />, m2_carrez ? `${m2_carrez}m² loi Carrez` : null, 3),
      createData(<EuroIcon />, details_loyer, 4),
      createData(<LocalOfferIcon />, statut_locatif, 5),
    ] : [
      createData(<HomeIcon />, descriptif_bien_2, 0),
      createData(<RoomIcon />, adresse_bien && ville ? `${adresse_bien}, ${ville}` : null, 1),
      createData(<LocationCityIcon />, quartier, 2),
      createData(<AspectRatioIcon />, m2_carrez ? `${m2_carrez}m² loi Carrez` : null, 3),
      createData(<LocalOfferIcon />, statut_locatif, 5),
    ];
  const [strategy, setStrategy] = useState(<Strategy1 clssName="strategy" />);

  useEffect(() => {
    if (strategie) {
      if (strategie.toLowerCase() === "placement")
        setStrategy(<Strategy1 clssName="strategy" />);
      else if (strategie.toLowerCase() === "équilibrée")
        setStrategy(<Strategy2 clssName="strategy" />);
      else if (strategie.toLowerCase() === "développement")
        setStrategy(<Strategy3 clssName="strategy" />);
    }
  }, [strategie]);

  return (
    <React.Fragment>
      <Divider text="Détails du bien" loader={loader} />
      <div
        className={`details-section ${isMobile === true || isTablet === true ? "mobile" : ""
          }`}
      >
        {/* Pills aggregates */}
        <div className="aggregates-wrapper">
          <div className="aggregates-container">
            <Pills
              label={prix_fai.label}
              value={prix_fai.value}
              loader={loader}
            />
            <Pills
              label={loyer_annuel.label}
              value={loyer_annuel.value}
              loader={loader}
            />
            <Pills
              label={rdmt_brut.label}
              value={rdmt_brut.value}
              loader={loader}
            />
          </div>
        </div>

        <div className="more-infos-container">
          <div className="left-container">
            {/* Text analyse */}
            <div className="analyse">
              {loader ? (
                <Skeleton
                  variant="rect"
                  animation="wave"
                  width="55vh"
                  height="30vh"
                  className="text-container"
                />
              ) : (
                <div className="text-container">
                  <Avatar
                    alt="large-avatar"
                    src={photo_charge_projet}
                    className="custom-avatar"
                  />
                  <h3>{`Le mot de l'analyste ${nom_prenom_cdp} :`}</h3>
                  <p>{resume}</p>
                </div>
              )}
            </div>

            {loader ? (
              <Skeleton
                variant="rect"
                animation="wave"
                width="65vh"
                height="17vh"
                className="strategy"
              />
            ) : (
              strategy
            )}
            <ModalResume />
          </div>

          {/* Analyse table */}
          <div className="table-container">
            <Table
              header="Informations essentielles"
              colNb={2}
              rows={rows}
              loader={loader}
              aspect="empty"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

DetailsOfRent.propTypes = {
  loader: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
};

export default DetailsOfRent;
